import {
  Col,
  Row,
  VertButton,
  VertContainer,
  VertRate,
  VertTypography,
} from '@vertem-core/vertice-ds';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { ArrowRightOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { VertSearch } from '@vertem-core/vertice-ds';
import ynToBool from 'Utils/ynToBool';
import { Flex } from 'antd';

const VertRateStore = ({ rate, total }) => {
  const ariaLabel = `${rate} de 5 baseada em ${total} avaliaç${
    total > 1 ? 'ões' : 'ão'
  }`;
  return (
    <div className="vert-card-store-rate" aria-label={ariaLabel}>
      <VertRate number={5} value={rate} disabled size="small" aria-hidden />
      {rate ? (
        <span className="vert-card-store-rate-average" aria-hidden>
          {rate}
        </span>
      ) : (
        ''
      )}
      {total ? (
        <span className="vert-card-store-rate-total" aria-hidden>
          ({total})
        </span>
      ) : (
        ''
      )}
    </div>
  );
};
VertRateStore.propTypes = {
  rate: PropTypes.number,
  total: PropTypes.number,
};


const VertCardStore = ({
  imageUrl,
  name,
  customUrlPage,
  rate,
  rateTotal,
  ...props
}) => {
  const Navigate = useNavigate();
  const Average = useSelector(({ Average }) => Average);

  return (
    <div className="vert-card-store">
      <Row shape="round" className="vert-card-store-wrapper" gutter={0}>
        <Col className="vert-card-store-box-image col-12 col-md-3 padding-x-extra-small">
          <div className="vert-card-store-image">
            <div
              className="vert-card-store-avatar"
              style={{ backgroundImage: `url(${imageUrl})` }}
              role="img"
              aria-label={name}
            />
          </div>
        </Col>
        <Col className="vert-card-store-box-content col-12 col-md-9 padding-x-extra-small">
          <VertTypography.Title level={2} className="vert-card-store-name">
            {name}
          </VertTypography.Title>

          <Row gutter={0} align="bottom">
            <Col span={24}>
              {() => {
                if (
                  !Average ||
                  !Average[props.supplierId] ||
                  Average[props.supplierId].isLoading ||
                  Average[props.supplierId].data === null
                ) {
                  return null;
                }
                return (
                  <VertRateStore
                    rate={Average[props.supplierId].data.average || 0}
                    total={Average[props.supplierId].data.totalCount || 0}
                  />
                );
              }}
            </Col>
            <Col span={24}>
              <VertButton
                type="link"
                spacing="none"
                size="small"
                className="color-detached vert-card-store-link"
                onClick={() => {
                  Navigate(customUrlPage);
                }}
              >
                Ir para produtos
                <ArrowRightOutlined />
              </VertButton>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
VertCardStore.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  customUrlPage: PropTypes.string.isRequired,
  rate: PropTypes.number,
  rateTotal: PropTypes.number,
};
const StoreListPage = () => {
  const Stores = useSelector(({ Stores }) => Stores);

  if (!Stores || Stores.isLoading) return null;

  const handleOrderItems = (items) => {
    return items.sort((a, b) => {
      const nomeA = a.name.toUpperCase();
      const nomeB = b.name.toUpperCase();

      if (nomeA < nomeB) {
        return -1;
      }
      if (nomeA > nomeB) {
        return 1;
      }
      return 0;
    });
  };

  const storesItems = handleOrderItems(Stores.ecommerce);
  const servicesItems = handleOrderItems(Stores.services);
  const [filtro, setFiltro] = useState('');
  const [resultadosFiltrados, setResultadosFiltrados] = useState(storesItems);
  const [resultadosServicosFiltrados, setResultadosServicos] =
    useState(servicesItems);

  const handleInputChange = (event) => {
    const valorInput = event.target.value;
    setFiltro(valorInput);

    const resultadosEcommerces = storesItems.filter((item) =>
      item.name.toLowerCase().includes(valorInput.toLowerCase())
    );
    const resultadosServices = servicesItems.filter((item) =>
      item.name.toLowerCase().includes(valorInput.toLowerCase())
    );

    setResultadosFiltrados(resultadosEcommerces);
    setResultadosServicos(resultadosServices);
  };

  const items =
    resultadosFiltrados.length > 0 ? (
      resultadosFiltrados.map((item, index) => {
        return (
          <Col
            xs={12}
            sm={12}
            md={8}
            lg={8}
            xl={6}
            className="padding-y-extra-small"
          >
            <VertCardStore
              data-testid={`carousel-item-${index}`}
              {...item}
              customUrlPage={`/store/${item.supplierId}/1`}
            />
          </Col>
        );
      })
    ) : (
      <Col span={24} className="padding-y-extra-small">
        <VertTypography.Paragraph>
          Não encontramos lojas para sua busca.
        </VertTypography.Paragraph>
      </Col>
    );
  const itemsServices =
    resultadosServicosFiltrados.length > 0 ? (
      resultadosServicosFiltrados.map((item, index) => {
        return (
          <Col
            xs={12}
            sm={12}
            md={8}
            lg={8}
            xl={6}
            className="padding-y-extra-small"
          >
            <VertCardStore
              data-testid={`carousel-item-${index}`}
              {...item}
              isService
            />
          </Col>
        );
      })
    ) : (
      <Col span={24} className="padding-y-extra-small">
        <VertTypography.Paragraph>
          Não encontramos serviços para sua busca.
        </VertTypography.Paragraph>
      </Col>
    );

  return (
    <VertContainer
      className="vert-container-page"
      spacingX="regular"
      spacingY="regular"
    >
      <Flex justify="flex-end" align="center">
        <VertSearch value={filtro} onChange={handleInputChange} />
      </Flex>

      {ynToBool(process.env.REACT_APP_SHOW_SERVICES_IN_STORE) && (
        <>
          <Row
            justify="center"
            align="middle"
            className="vert-category vert-category-title"
            gutter={8}
          >
            <Col className="vert-category vert-category-title-label col-12-12 col-lg margin-bottom-extra-small">
              <VertTypography.Title level={2} className="margin-bottom-none">
                Serviços pensados pra você
              </VertTypography.Title>
            </Col>
          </Row>
          <Row gutter={16}>{itemsServices}</Row>
        </>
      )}

      <Row
        justify="center"
        align="middle"
        className="vert-category vert-category-title margin-top-big margin-bottom-small"
        gutter={8}
      >
        <Col className="vert-category vert-category-title-label col">
          <VertTypography.Title level={2} className="margin-bottom-none">
            As melhores lojas pra você
          </VertTypography.Title>
        </Col>
      </Row>
      <Row gutter={16}>{items}</Row>
    </VertContainer>
  );
};

export default StoreListPage;
